module.exports = __webpack_public_path__ + "img/illustration-1.2966bbe2.svg";